import parseNumber from "@tKgpco/utilities/parseNumber";
import Color from "color";

const STATIC_PATH = "/userfiles/_static/store";

// -- Colors

const swatch = {
    white: "#ffffff",
    black: "#000000",
    grey: {
        lighter: "#F6F6F6",
        light: "#F3F5F7",
        base: "#A7ABB0",
        dark: "#55595D",
        darker: "#000000",
        shade: "#F1F6FB",
    },
};

export const COLORS = {
    white: swatch.white,
    black: swatch.black,
    lightBlack: "#353432",
    secondaryBtn: "#0D70B7",
    secondaryBg: "#EDF4F8",
    primary: {
        light: "#0B70B7",
        base: "#0B70B7",
        dark: "#0B70B7",
        contrast: "white",
    },
    secondary: {
        light: "white",
        base: "white",
        dark: "white",
        contrast: "#0D70B7",
    },
    tertiary: {
        light: "#676767",
        base: "#676767",
        dark: "#676767",
        contrast: "black",
    },
    success: "#3CB56F",
    warning: "#E8AA0F",
    error: "#E23939",
    info: {
        base: "#3D3D3D",
    },
    background: {
        base: swatch.white,
        alt: swatch.grey.lighter,
        hover: swatch.grey.light,
        tag: swatch.grey.base,
        shade: swatch.grey.shade,
    },
    border: {
        base: "#e2e3e6",
        dark: "#5d5f62",
        darker: swatch.grey.darker,
    },
    disabled: {
        lighter: "#e2e3e6",
        light: swatch.grey.light,
        base: "#939393",
        dark: swatch.grey.dark,
    },
    text: {
        lighter: swatch.grey.base,
        light: swatch.grey.dark,
        base: swatch.grey.darker,
        erpNumber: "#666",
    },
    link: {
        base: "#1E75BA",
        hover: swatch.grey.dark,
    },
    shadow: {
        light: "rgba(48, 49, 51, 0.05)",
        base: "rgba(48, 49, 51, 0.1)",
    },
    pagination: {
        base: swatch.grey.light,
        hover: Color(swatch.grey.light).darken(0.15).hex(),
    },
    outline: "#1d8ed5",
};

// -- Typography

const fallbackFont = "Arial, Helvetica, sans-serif";

export const TYPOGRAPHY = {
    fontFamily: {
        title: `'Roboto', ${fallbackFont}`,
        base: `'Roboto', ${fallbackFont}`,
    },
    weight: {
        base: 400,
        bold: 600,
        black: 900,
    },
    size: {
        veryTiny: "10px",
        vTiny: "11px",
        tiny: "12px",
        smallest: "13px",
        smaller: "14px",
        small: "15px",
        base: "16px",
        large: "18px",
        larger: "20px",
        largest: "24px",
        xlargest: "26px",
        xlarge: "30px",
    },
    lineHeight: {
        smaller: 1,
        small: 1.25,
        base: 1.5,
        large: 2,
    },
    spacing: {
        small: "0.5em",
        base: "1em",
        large: "1.5em",
        larger: "2em",
        largest: "3em",
    },
};

// -- Spacings
export const SPACING = {
    xxxlarge: "4em",
    xxlarge: "3em",
    xlarge: "2em",
    large: "1.5em",
    medium: "1.25em",
    standard: "1em",
    small: ".75em",
    xsmall: ".5em",
    xxsmall: ".25em",
    none: "0",
};

// -- Product

const productImageSizes = {
    small: {
        width: 311,
        height: 193,
    },
    medium: {
        width: 690,
        height: 429,
    },
    large: {
        width: 1164,
        height: 724,
    },
};

export const PRODUCT = {
    image: {
        ...productImageSizes,
        ratio: productImageSizes.large.height / productImageSizes.large.width,
    },
};

// -- Common

const contentWidth = 1410;

const spacing = {
    side: ["20px", "30px", "45px", "70px", "70px"],
    content: ["25px", "30px", "45px", "35px", "60px"],
    narrowContent: ["25px", "30px", "40px", "40px", "50px"],
};

const largestSideSpacing = spacing.side.filter(x => x).pop() as any;
const siteWidth = contentWidth + (parseNumber(largestSideSpacing) ?? 0) * 2;
// const siteWidth = 1440;

export const COMMON = {
    breakpoints: [0, 600, 900, 990, siteWidth],
    width: {
        content: contentWidth,
        site: siteWidth,
    },
    spacing,
    outline: {
        width: "2px",
        style: "solid",
    },
    defaultProductImagePath: `${STATIC_PATH}/product-not-available.svg`,
    defaultCategoryImagePath: `${STATIC_PATH}/category-not-available.svg`,
};

// -- Menu

export const MENU = {
    mobileButtonSpacing: ".25em",
    topNavItemSpacing: ".8em",
};

// -- Form

export const FORM = {
    field: {
        padding: "1em",
        spacing: "1em",
    },
    button: {
        spacing: "1.6em",
    },
};
